import React, { useEffect } from "react";

import { noop, getYoutubeEmbedUrl } from "utils/common";

import "./YoutubePreview.css";

export default function YoutubePreview({ youtubeUrl, onLoad }) {
	const src = getYoutubeEmbedUrl(youtubeUrl);

	useEffect(() => {
		if(!src){ onLoad(); }
	}, [src]);

	if(!src){
		return (
			<div className="youtube-preview-frame">
				<div className="preview-unavailable">
					Preview unavailable
				</div>
			</div>
		);
	}

	return (
		<div className="youtube-preview-frame">
			<iframe
				src={src}
				allowFullScreen
				onLoad={onLoad}
			/>
		</div>
	);
}

YoutubePreview.displayName = "YoutubePreview";
YoutubePreview.defaultProps = {
	onLoad: noop,
};
